const appSlideFiles = [
  '01.jpg',
  '02.jpg',
  '03.jpg',
  '04.jpg',
  '05.jpg',
  '06.jpg',
];

const appSlides = appSlideFiles.map((fileName, index) => ({
  id: `app-slide-${index + 1}`,
  name: `App slide ${index + 1}`,
  image: `/img/apps/${fileName}`,
}));

export default appSlides;
